import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting, Adres, APV, Effecten,
  GiftTaxEntity,
  IntermediaryEntity, NotarieleAkte, OmschrijvingEnBedrag, OndernemingSB, OnroerendeZaakSB, PU, RoerendeZaak,
  Schenking, SchenkingOpPapier, SchenkingRelatieBegiftigdeMetSchenker, Vrijstellingen, Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import { SharedUiTooltipModule } from '@snelstart/ui-tooltip';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-akte',
  standalone: true,
    imports: [
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        NgIf,
        SharedUiTooltipModule
    ],
  templateUrl: './akte.component.html',
  styleUrl: './akte.component.css'
})
export class AkteComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private intermediaryEntitySubscription: Subscription | undefined;
  private giftTaxEntitySubscription: Subscription | undefined;
  public intermediary = {} as IntermediaryEntity;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public schenkingFg = {} as FormGroup;
  public akteFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsLandcodes: SelectFormControlItem<string>[] = [
    {value: "NLD", label: "Nederland"},
    {value: "", label: "----------------------------------"},
    {value: "ALB", label: "Albanië"},
    {value: "ARG", label: "Argentinië"},
    {value: "ARM", label: "Armenië"},
    {value: "ABW", label: "Aruba"},
    {value: "AUS", label: "Australië"},
    {value: "AZE", label: "Azerbeidjan"},
    {value: "BHR", label: "Bahrein"},
    {value: "BGD", label: "Bangladesh"},
    {value: "BRB", label: "Barbedos"},
    {value: "BLR", label: "Belarus (Wit-Rusland)"},
    {value: "BEL", label: "België"},
    {value: "BMU", label: "Bermuda"},
    {value: "BES", label: "Bonaire, St. Eustatius en Saba"},
    {value: "BIH", label: "Bosnië-Herzegovina"},
    {value: "BRA", label: "Brazilië"},
    {value: "BGR", label: "Bulgarije"},
    {value: "CAN", label: "Canada"},
    {value: "CHN", label: "China"},
    {value: "CUW", label: "Curaçao"},
    {value: "CYP", label: "Cyprus"},
    {value: "DNK", label: "Denemarken"},
    {value: "DEU", label: "Duitsland"},
    {value: "EGY", label: "Egypte"},
    {value: "EST", label: "Estland"},
    {value: "PHL", label: "Filippijnen"},
    {value: "FIN", label: "Finland"},
    {value: "FRA", label: "Frankrijk"},
    {value: "GEO", label: "Georgië"},
    {value: "GHA", label: "Ghana"},
    {value: "GRC", label: "Griekenland"},
    {value: "HUN", label: "Hongarije"},
    {value: "HKG", label: "Hongkong"},
    {value: "IRL", label: "Ierland"},
    {value: "ISL", label: "IJsland"},
    {value: "IND", label: "India"},
    {value: "IDN", label: "Indonesië"},
    {value: "ISR", label: "Israël"},
    {value: "ITA", label: "Italië"},
    {value: "JPN", label: "Japan"},
    {value: "JOR", label: "Jordanië"},
    {value: "KAZ", label: "Kazachstan"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KWT", label: "Koeweit"},
    {value: "HRV", label: "Kroatië"},
    {value: "LVA", label: "Letland"},
    {value: "LTU", label: "Litouwen"},
    {value: "LUX", label: "Luxemburg"},
    {value: "MKD", label: "Macedonië"},
    {value: "MWI", label: "Malawi"},
    {value: "MYS", label: "Maleisië"},
    {value: "MLT", label: "Malta"},
    {value: "MAR", label: "Marokko"},
    {value: "MEX", label: "Mexico"},
    {value: "MDA", label: "Moldavië"},
    {value: "MNE", label: "Montenegro"},
    {value: "NZL", label: "Nieuw-Zeeland"},
    {value: "NGA", label: "Nigeria"},
    {value: "NOR", label: "Noorwegen"},
    {value: "UKR", label: "Oekraïne"},
    {value: "UZB", label: "Oezbekistan"},
    {value: "OMN", label: "Oman"},
    {value: "AUT", label: "Oostenrijk"},
    {value: "PAK", label: "Pakistan"},
    {value: "PAN", label: "Panama"},
    {value: "POL", label: "Polen"},
    {value: "PRT", label: "Portugal"},
    {value: "QAT", label: "Qatar"},
    {value: "ROU", label: "Roemenië"},
    {value: "RUS", label: "Rusland"},
    {value: "SAU", label: "Saudi-Arabië"},
    {value: "SRB", label: "Servië"},
    {value: "SGP", label: "Singapore"},
    {value: "SXM", label: "Sint Maarten"},
    {value: "SVN", label: "Slovenië"},
    {value: "SVK", label: "Slowakije"},
    {value: "ESP", label: "Spanje"},
    {value: "LKA", label: "Sri Lanka"},
    {value: "SUR", label: "Suriname"},
    {value: "TJK", label: "Tadzjikistan"},
    {value: "TWN", label: "Taiwan"},
    {value: "THA", label: "Thailand"},
    {value: "CZE", label: "Tsjechië"},
    {value: "TUN", label: "Tunesië"},
    {value: "TUR", label: "Turkije"},
    {value: "UGA", label: "Uganda"},
    {value: "VEN", label: "Venezuela"},
    {value: "GBR", label: "Verenigd Koninkrijk"},
    {value: "ARE", label: "Verenigde Arabische Emiraten"},
    {value: "USA", label: "Verenigde Staten van Amerika"},
    {value: "VNM", label: "Vietnam"},
    {value: "ZMB", label: "Zambia"},
    {value: "ZWE", label: "Zimbabwe"},
    {value: "ZAF", label: "Zuid-Afrika"},
    {value: "KOR", label: "Zuid-Korea"},
    {value: "SWE", label: "Zweden"},
    {value: "CHE", label: "Zwitserland"}
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
    })
    this.akteFg = this.fb.group<NotarieleAkte>({
      akteAanwezig: false,
      datumAkte: null as unknown as Date,
      cdrNummer: null as unknown as string,
      notarisProtocolnummer: null as unknown as string,
      naamNotariskantoor: null as unknown as string,
      adresNotariskantoor: this.fb.group<Adres>({
        straat: null as unknown as string,
        huisNummer: null as unknown as number,
        huisNummerToevoeging: null as unknown as string,
        postcode: null as unknown as string,
        woonplaats: null as unknown as string,
        landCode: null as unknown as string,
      }),
    })
  }

  ngOnInit(): void {
    this.intermediaryEntitySubscription = this.algDataService.intermediary.subscribe((value) => {
      this.intermediary = value;
    })
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value) => {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0],{emitEvent: false})
        if (value.aangifte?.schenking[0].notarieleAkte) {
          this.akteFg.patchValue(value.aangifte?.schenking[0].notarieleAkte, {emitEvent: false})
        }
        if (value.aangifte!.schenking[0].notarieleAkte?.datumAkte) {
          this.akteFg.get('akteAanwezig')?.setValue(true);
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.intermediaryEntitySubscription) {
      this.intermediaryEntitySubscription.unsubscribe()
    }
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.akteFg.updateValueAndValidity({ emitEvent: false });
    this.schenkingFg.updateValueAndValidity({ emitEvent: false });
    const schenking = this.schenkingFg.value;
    const akteAanwezig = this.akteFg.value.akteAanwezig;
    schenking.notarieleAkte = {
      akteAanwezig,
      datumAkte: akteAanwezig ? this.akteFg.value.datumAkte : null,
      cdrNummer: akteAanwezig ? this.akteFg.value.cdrNummer : null,
      notarisProtocolnummer: akteAanwezig ? this.akteFg.value.notarisProtocolnummer : null,
      naamNotariskantoor: akteAanwezig ? this.akteFg.value.naamNotariskantoor : null,
      adresNotariskantoor: akteAanwezig ? this.akteFg.value.adresNotariskantoor : null
    };
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
  }
}
